import { useDispatch, useSelector } from 'react-redux';
import TreeSliderInputField from './TreeSliderInputField';
import { convertFeetToMetric, convertMetricToFeet } from '../../util';
import { selectTreeState } from 'store/slices/TreeSlice/selector';
import { updateTree } from 'store/slices/TreeSlice';
import { TreeFieldItem } from './styles';

type Props = {
	isActive: boolean;
	onActivate: () => void;
	disabled?: boolean;
};

const MIN_HEIGHT = 0;
const INPUT_MAX_HEIGHT = convertMetricToFeet(100, 'm', 1);
const SLIDER_MAX_HEIGHT = INPUT_MAX_HEIGHT;
const STEP = 1;

export default function TreeHeightField({ isActive, onActivate, disabled }: Props) {
	const dispatch = useDispatch();
	const { selectedTreeId, selectedTree } = useSelector(selectTreeState);

	if (!selectedTreeId || !selectedTree) return null;

	const treeHeight = selectedTree.treeHeight ?? 0;
	const value = convertMetricToFeet(treeHeight, 'm', 1);

	const updateValue = (next: number) => {
		const normalized = Number.isFinite(next)
			? Math.max(MIN_HEIGHT, Math.min(INPUT_MAX_HEIGHT, next))
			: MIN_HEIGHT;
		const newHeightM = convertFeetToMetric(normalized, 'm', 6);
		dispatch(updateTree({
			id: selectedTreeId,
			tree: {
				treeHeight: newHeightM,
			}
		}));
	};

	return (
		<TreeFieldItem>
			<TreeSliderInputField
				id="tree-height"
				label="Tree Height"
				value={value}
				min={MIN_HEIGHT}
				max={INPUT_MAX_HEIGHT}
				sliderMax={SLIDER_MAX_HEIGHT}
				step={STEP}
				unit="ft"
				isActive={isActive}
				onActivate={onActivate}
				onInputChange={updateValue}
				showSlider={true}
				disabled={disabled}
			/>
		</TreeFieldItem>
	);
}
